import request from '@u/request'

// 上传图片
export function upload_image(data){
	return request({
		headers:{
			'Content-Type':'application/x-www-form-urlencoded'
		},
		url: '/cms/upload_image',
		method: 'POST',
		data: data || {}
	})
}


// -------------特训营--------------
// 特训营列表
export function campList(data){
	return request({
		url: '/cms_seven/campList',
        method: 'POST',
        data: data || {}
	})
}

// 特训营添加
export function campAdd(data){
	return request({
		url: '/cms_seven/campAdd',
        method: 'POST',
        data: data || {}
	})
}

// 特训营查询
export function campEdit(data){
	return request({
		url: '/cms_seven/campEdit',
        method: 'POST',
        data: data || {}
	})
}

// 获取学员信息
export function getInfo(data){
	return request({
		url: '/cms_seven/getInfo',
        method: 'POST',
        data: data || {}
	})
}

// -------------拼团--------------
// 拼团列表
export function missionList(data){
	return request({
		url: '/cms_seven/missionList',
        method: 'POST',
        data: data || {}
	})
}

// 拼团添加
export function missionAdd(data){
	return request({
		url: '/cms_seven/missionAdd',
        method: 'POST',
        data: data || {}
	})
}

// 拼团查询
export function missionEdit(data){
	return request({
		url: '/cms_seven/missionEdit',
        method: 'POST',
        data: data || {}
	})
}

// 拼团获取课程列表
export function missionCamp(data){
	return request({
		url: '/cms_seven/missionCamp',
        method: 'POST',
        data: data || {}
	})
}
// 关闭/开启拼团状态
export function closeMission(data){
	return request({
		url: '/cms_seven/closeMission',
        method: 'POST',
        data: data || {}
	})
}
// 拼团详情
export function missionDetail(data){
	return request({
		url: '/cms_seven/missionDetail',
        method: 'POST',
        data: data || {}
	})
}

// -------------订单管理--------------
// 订单列表
export function orderList(data){
	return request({
		url: '/cms_seven/orderList',
        method: 'POST',
        data: data || {}
	})
}


// 导出订单
export function exportOrder(data){
	return request({
		url: '/cms_seven/exportOrder',
        method: 'POST',
        data: data || {}
	})
}

// -------------海报管理--------------
// 海报列表
export function postersList(data){
	return request({
		url: '/cms_seven/postersList',
        method: 'POST',
        data: data || {}
	})
}


// 海报添加/修改
export function postersAdd(data){
	return request({
		url: '/cms_seven/postersAdd',
        method: 'POST',
        data: data || {}
	})
}

// 海报预览
export function postersPreview(data){
	return request({
		url: '/cms_seven/postersPreview',
        method: 'POST',
        data: data || {}
	})
}
// 海报查询
export function postersEdit(data){
	return request({
		url: '/cms_seven/postersEdit',
        method: 'POST',
        data: data || {}
	})
}

// -------------佣金管理--------------
// 佣金列表
export function campFee(data){
	return request({
		url: '/cms_seven/campFee',
        method: 'POST',
        data: data || {}
	})
}
// 佣金设置
export function setFee(data){
	return request({
		url: '/cms_seven/setFee',
        method: 'POST',
        data: data || {}
	})
}
// 佣金设置 新
export function setRule(data){
	return request({
		url: '/cms_seven/setRule',
        method: 'POST',
        data: data || {}
	})
}

// -------------推广管理--------------
// 推广员列表
export function promoterList(data){
	return request({
		url: '/cms_seven/promoterList',
        method: 'POST',
        data: data || {}
	})
}
// 推广员列表 -- 获取推广员等级
export function getRule(data){
	return request({
		url: '/cms_seven/getRule',
        method: 'POST',
        data: data || {}
	})
}
// 推广员列表 -- 设置推广员等级
export function setLevel(data){
	return request({
		url: '/cms_seven/setLevel',
        method: 'POST',
        data: data || {}
	})
}

// 导出推广员列表
export function promoterExport(data){
	return request({
		url: '/cms_seven/promoterExport',
        method: 'POST',
        data: data || {}
	})
}

// 	推广员详情
export function promoterDetail(data){
	return request({
		url: '/cms_seven/promoterDetail',
        method: 'POST',
        data: data || {}
	})
}

// 推广员邀请人列表
export function promoterInvited(data){
	return request({
		url: '/cms_seven/promoterInvited',
        method: 'POST',
        data: data || {}
	})
}

// 推广员审核列表
export function applyList(data){
	return request({
		url: '/cms_seven/applyList',
        method: 'POST',
        data: data || {}
	})
}

// 推广员审核列表 -- 改变审核状态
export function setApplyStatus(data){
	return request({
		url: '/cms_seven/setApplyStatus',
        method: 'POST',
        data: data || {}
	})
}

// 推广记录，只查询购买成功的
export function promoterLogs(data){
	return request({
		url: '/cms_seven/promoterLogs',
        method: 'POST',
        data: data || {}
	})
}

// 导出推广记录
export function exportLogs(data){
	return request({
		url: '/cms_seven/exportLogs',
        method: 'POST',
        data: data || {}
	})
}

// 招募设置  -- 查询
export function getPage(data){
	return request({
		url: '/cms_seven/getPage',
        method: 'POST',
        data: data || {}
	})
}

// 招募设置  -- 添加
export function setPage(data){
	return request({
		url: '/cms_seven/setPage',
        method: 'POST',
        data: data || {}
	})
}

// -------------业绩管理--------------
// 业绩列表
export function promoterStatistics(data){
	return request({
		url: '/cms_seven/promoterStatistics',
        method: 'POST',
        data: data || {}
	})
}
// 业绩导出
export function exportStatistics(data){
	return request({
		url: '/cms_seven/exportStatistics',
        method: 'POST',
        data: data || {}
	})
}

// -------------邀请语管理--------------
// 邀请语列表
export function inviteList(data){
	return request({
		url: '/cms_seven/inviteList',
        method: 'POST',
        data: data || {}
	})
}
// 邀请语添加/修改
export function inviteAdd(data){
	return request({
		url: '/cms_seven/inviteAdd',
        method: 'POST',
        data: data || {}
	})
}
// 邀请语查询
export function inviteEdit(data){
	return request({
		url: '/cms_seven/inviteEdit',
        method: 'POST',
        data: data || {}
	})
}

// -------------标签管理--------------
// 标签列表
export function labelList(data){
	return request({
		url: '/cms_label/labelList',
        method: 'POST',
        data: data || {}
	})
}

// 删除标签
export function labelDel(data){
	return request({
		url: '/cms_label/labelDel',
        method: 'POST',
        data: data || {}
	})
}

// 添加标签
export function labelAdd(data){
	return request({
		url: '/cms_label/labelAdd',
        method: 'POST',
        data: data || {}
	})
}

// 查询标签
export function labelEdit(data){
	return request({
		url: '/cms_label/labelEdit',
        method: 'POST',
        data: data || {}
	})
}
// 查询用户信息
export function getUser(data){
	return request({
		url: '/cms_label/getUser',
        method: 'POST',
        data: data || {}
	})
}
// 删除用户信息
export function listDel(data){
	return request({
		url: '/cms_label/listDel',
        method: 'POST',
        data: data || {}
	})
}

// 标签复制
export function labelCopy(data){
	return request({
		url: '/cms_label/labelCopy',
        method: 'POST',
        data: data || {}
	})
}

// -------------推广活动--------------
// 标签列表
export function eventsList(data){
	return request({
		url: '/cms_label/eventsList',
        method: 'POST',
        data: data || {}
	})
}
// 获取课程列表
export function getBigCourse(data){
	return request({
		url: '/cms_label/getBigCourse',
        method: 'POST',
        data: data || {}
	})
}// 添加推广活动
export function eventsAdd(data){
	return request({
		url: '/cms_label/eventsAdd',
        method: 'POST',
        data: data || {}
	})
}// 推广活动修改获取内容
export function eventsEdit(data){
	return request({
		url: '/cms_label/eventsEdit',
        method: 'POST',
        data: data || {}
	})
}// 获取标签列表
export function eventLabelList(data){
	return request({
		url: '/cms_label/eventLabelList',
        method: 'POST',
        data: data || {}
	})
}// 删除推广活动标签
export function eventLabelDel(data){
	return request({
		url: '/cms_label/eventLabelDel',
        method: 'POST',
        data: data || {}
	})
}

// 查询商品列表
export function financialList(data){
	return request({
		url: '/cms_statistics/financialList',
        method: 'POST',
        data: data || {}
	})
}

// 导出商品列表
export function exportFinancial(data){
	return request({
		url: '/cms_statistics/exportFinancial',
        method: 'POST',
        data: data || {}
	})
}

// PBL财务统计
export function financialStat(data){
	return request({
		url: '/cms_statistics/financialStat',
        method: 'POST',
        data: data || {}
	})
}

// 查询用户列表
export function financialUserList(data){
	return request({
		url: '/cms_statistics/financialUserList',
        method: 'POST',
        data: data || {}
	})
}

// 导出用户列表
export function exportFinancialUser(data){
	return request({
		url: '/cms_statistics/exportFinancialUser',
        method: 'POST',
        data: data || {}
	})
}

// 课程订单统计列表
export function courseOrderList(data){
	return request({
		url: '/cms_statistics/orderList',
        method: 'POST',
        data: data || {}
	})
}
// 课程订单备注提交
export function remark(data){
	return request({
		url: '/cms_statistics/remark',
        method: 'POST',
        data: data || {}
	})
}

// 拼团管理---列表
export function scrabble_list(data){
	return request({
		url: '/cms_scrabble/list',
        method: 'POST',
        data: data || {}
	})
}
// 拼团管理---查询
export function scrabble_edit(data){
	return request({
		url: '/cms_scrabble/edit',
        method: 'POST',
        data: data || {}
	})
}
// 拼团管理---添加修改
export function scrabble_editdo(data){
	return request({
		url: '/cms_scrabble/editdo',
        method: 'POST',
        data: data || {}
	})
}
// 拼团管理---开团列表
export function scrabble_scrabblelist(data){
	return request({
		url: '/cms_scrabble/scrabblelist',
        method: 'POST',
        data: data || {}
	})
}
// 小鹅通反馈统计
export function statList(data){
	return request({
		url: '/cms_xiaoe/statList',
        method: 'POST',
        data: data || {}
	})
}

// 小鹅通反馈统计添加
export function addStat(data){
	return request({
		url: '/cms_xiaoe/addStat',
        method: 'POST',
        data: data || {}
	})
}

// 小鹅通反馈统计修改
export function updateStat(data){
	return request({
		url: '/cms_xiaoe/updateStat',
        method: 'POST',
        data: data || {}
	})
}

// 小鹅通反馈统计查询
export function getStat(data){
	return request({
		url: '/cms_xiaoe/getStat',
        method: 'POST',
        data: data || {}
	})
}
// 小鹅通转化统计（备注修改）
export function updateStatRemark(data){
	return request({
		url: '/cms_xiaoe/updateStatRemark',
        method: 'POST',
        data: data || {}
	})
}

// 小鹅通转化统计详情
export function statDetail(data){
	return request({
		url: '/cms_xiaoe/statDetail',
        method: 'POST',
        data: data || {}
	})
}

// -------7天训练营分班管理---------

// 班级列表
export function classroomList(data){
	return request({
		url: '/cms_xiaoe/classroomList',
        method: 'POST',
        data: data || {}
	})
}

// 添加班级
export function addClassroom(data){
	return request({
		url: '/cms_xiaoe/addClassroom',
        method: 'POST',
        data: data || {}
	})
}

// 修改班级
export function updateClassroom(data){
	return request({
		url: '/cms_xiaoe/updateClassroom',
        method: 'POST',
        data: data || {}
	})
}

// 获取班级
export function getClassroom(data){
	return request({
		url: '/cms_xiaoe/getClassroom',
        method: 'POST',
        data: data || {}
	})
}

// 全部班级
export function classroomAll(data){
	return request({
		url: '/cms_xiaoe/classroomAll',
        method: 'POST',
        data: data || {}
	})
}
// 用户列表
export function userList(data){
	return request({
		url: '/cms_xiaoe/userList',
        method: 'POST',
        data: data || {}
	})
}
// 用户导出
export function userExport(data){
	return request({
		url: '/cms_xiaoe/userExport',
        method: 'POST',
        data: data || {}
	})
}
// 查看班级用户
export function gradeUserList(data){
	return request({
		url: '/cms_teacher/userList',
        method: 'POST',
        data: data || {}
	})
}


// -------直播数据汇总---------

// 直播间列表
export function getRooms(data){
	return request({
		url: '/cms_bokecc/getRooms',
        method: 'POST',
        data: data || {}
	})
}

// 统计列表
export function statisList(data){
	return request({
		url: '/cms_bokecc/statisList',
        method: 'POST',
        data: data || {}
	})
}

// 统计导出
export function statisAll(data){
	return request({
		url: '/cms_bokecc/statisAll',
        method: 'POST',
        data: data || {}
	})
}

// 直播数据统计迭代 2

// 统计列表
export function userStatisList(data){
	return request({
		url: '/cms_bokecc/userStatisList',
        method: 'POST',
        data: data || {}
	})
}

// 统计导出
export function userStatisAll(data){
	return request({
		url: '/cms_bokecc/userStatisAll',
        method: 'POST',
        data: data || {}
	})
}

// 导入白名单
export function addWhiteList(data){
	return request({
		url: '/cms_bokecc/addWhiteList',
        method: 'POST',
        data: data || {}
	})
}

// 用户名单查看
export function viewWhiteList(data){
	return request({
		url: '/cms_bokecc/viewWhiteList',
        method: 'POST',
        data: data || {}
	})
}

// 用户名单清空
export function clearWhiteList(data){
	return request({
		url: '/cms_bokecc/clearWhiteList',
        method: 'POST',
        data: data || {}
	})
}


// ----------续报转介----------

// 获取课程列表（getCourseList）
export function getCourseList(data){
	return request({
		url: '/cms_statistics/getCourseList',
        method: 'POST',
        data: data || {}
	})
}

// 获取续报转介总数（getStatCount）
export function getStatCount(data){
	return request({
		url: '/cms_statistics/getStatCount',
        method: 'POST',
        data: data || {}
	})
}

//获取续报转介单日数据（getStatCountResult）
export function getStatCountResult(data){
	return request({
		url: '/cms_statistics/getStatCountResult',
        method: 'POST',
        data: data || {}
	})
}

//转介续报总数统计（reorderStatCount）
export function reorderStatCount(data){
	return request({
		url: '/cms_statistics/reorderStatCount',
        method: 'POST',
        data: data || {}
	})
}

//转介续报列表（reorderStatList）
export function reorderStatList(data){
	return request({
		url: '/cms_statistics/reorderStatList',
        method: 'POST',
        data: data || {}
	})
}

//转介续报导出（reorderStatAll）
export function reorderStatAll(data){
	return request({
		url: '/cms_statistics/reorderStatAll',
        method: 'POST',
        data: data || {}
	})
}

//转介明细（referralDetail）
export function referralDetail(data){
	return request({
		url: '/cms_statistics/referralDetail',
        method: 'POST',
        data: data || {}
	})
}


// =====================海报自动生成=============
// ==========
//活动管理---活动列表
export function activityList(data){
	return request({
		url: '/cms_op/activityList',
        method: 'POST',
        data: data || {}
	})
}

//全部活动
export function activityAll(data){
	return request({
		url: '/cms_op/activityAll',
        method: 'POST',
        data: data || {}
	})
}
//获取活动
export function getActivity(data){
	return request({
		url: '/cms_op/getActivity',
        method: 'POST',
        data: data || {}
	})
}
//添加活动
export function addActivity(data){
	return request({
		url: '/cms_op/addActivity',
        method: 'POST',
        data: data || {}
	})
}
//修改活动
export function updateActivity(data){
	return request({
		url: '/cms_op/updateActivity',
        method: 'POST',
        data: data || {}
	})
}

// =========海报管理======
//海报列表
export function posterList(data){
	return request({
		url: '/cms_op/posterList',
        method: 'POST',
        data: data || {}
	})
}
//获取海报
export function getPoster(data){
	return request({
		url: '/cms_op/getPoster',
        method: 'POST',
        data: data || {}
	})
}
//添加海报
export function addPoster(data){
	return request({
		url: '/cms_op/addPoster',
        method: 'POST',
        data: data || {}
	})
}
//修改海报
export function updatePoster(data){
	return request({
		url: '/cms_op/updatePoster',
        method: 'POST',
        data: data || {}
	})
}
//删除海报
export function deletePoster(data){
	return request({
		url: '/cms_op/deletePoster',
        method: 'POST',
        data: data || {}
	})
}
//预览海报
export function previewPoster(data){
	return request({
		url: '/cms_op/previewPoster',
        method: 'POST',
        data: data || {}
	})
}

//解析元素JSON
export function parseComponents(data){
	return request({
		url: '/cms_op/parseComponents',
        method: 'POST',
        data: data || {}
	})
}
//生成元素JSON
export function createComponents(data){
	return request({
		url: '/cms_op/createComponents',
        method: 'POST',
        data: data || {}
	})
}